import React from 'react';
import { Truck, Shield, Clock, Award } from 'lucide-react';

export const Features = () => {
  const features = [
    {
      icon: Truck,
      title: 'Countrywide Delivery',
      description: 'Free shipping on orders above KES 5,000',
    },
    {
      icon: Shield,
      title: 'Secure Shopping',
      description: 'Safe and secure payment methods',
    },
    {
      icon: Clock,
      title: '24/7 Support',
      description: 'Round the clock customer service',
    },
    {
      icon: Award,
      title: 'Premium Quality',
      description: 'Guaranteed authentic products',
    },
  ];

  return (
    <section className="py-12 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div
                key={index}
                className="flex flex-col items-center text-center p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow"
              >
                <Icon className="h-10 w-10 text-pink-500 mb-4" />
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  {feature.title}
                </h3>
                <p className="text-gray-600">{feature.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};